<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
import "@/assets/css/default.css";
// import changeFont from './assets/js/base.js';
import "@/assets/images/sprite.css";




export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/common.scss";
#app {
  min-width:1200px;
}

</style>
